// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3j3VY","col":"CardReaderDesc_col__3wdb0","label":"CardReaderDesc_label__2ZUsW"};